import { Component } from 'react'
import PropTypes from 'prop-types'

import Icon from '../Icons'

class StoreBanner extends Component {
  render() {
    const { title, btnText, icon, classes, onClick } = this.props
    return (
      <div className={`ctp-store-banner ${classes || ''}`}>
        <div className="ctp-store-banner__inner">
          <h2>{title}</h2>
          <span>
            <Icon icon={icon} />
          </span>
          <button className="button button-white" onClick={onClick}>
            {btnText}
          </button>
        </div>
      </div>
    )
  }
}

StoreBanner.propTypes = {
  classes: PropTypes.string,
  title: PropTypes.string,
  btnText: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
}

export default StoreBanner
